export enum ECounterpartyType {
  Bank = 'bank',
  Customer = 'customer',
  NotSelected = 'Not selected',
}
